import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface LineEquationProps {
  yLabel: string;
  xLabel: string;
  equation?: "linear" | "quadratic";
}

function LineEquation(props: LineEquationProps) {
  const { xLabel, yLabel, equation = "linear" } = props;
  const { t } = useTranslation();

  const equations = useMemo(
    () => ({
      linear: `{${yLabel}} = m * {${xLabel}} + b`,
      quadratic: `{${yLabel}} = a * {${xLabel}}² + b * {${xLabel}} + c`,
    }),
    [xLabel, yLabel]
  );

  return (
    <>
      <Typography color="textSecondary" variant="caption">
        {t("components.line_equation")}
      </Typography>
      <Typography variant="caption" sx={{ display: "inline" }}>
        <Box component="span" sx={{ color: "textPrimary.main" }}>
          {equations[equation]}
        </Box>
      </Typography>
    </>
  );
}

export default LineEquation;
